import { View } from "react-native";

type CarouselProps = Readonly<{
  count: number;
  activeIndex: number;
}>;

const NewsCarouselDots = ({ count, activeIndex }: CarouselProps) => {
  return (
    <View className="flex-row justify-center gap-1.5 mt-1">
      {Array.from({ length: count }).map((_, i) => (
        <View
          key={i}
          className={`h-1.5 rounded-full ${
            i === activeIndex ? "w-4 bg-primary" : "w-1.5 bg-ash-3"
          }`}
        />
      ))}
    </View>
  );
};

export default NewsCarouselDots;
